import {createSelector} from 'reselect';

import {getUIState} from '../../../ui-selectors';

const getEngagementSalesState = createSelector([getUIState], (uiState) => uiState.engagementSales);

const getEngagementSalesChartState = createSelector(
    [getEngagementSalesState],
    (engagementSales) => engagementSales.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getEngagementSalesChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getEngagementSalesChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getEngagementSalesChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getEngagementSalesChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);

// List selectors
const getEngagementSalesListState = createSelector(
    [getEngagementSalesState],
    (engagementSales) => engagementSales.leadsList
);

const getEngagementSalesSummaryStatsState = createSelector(
    [getEngagementSalesState],
    (engagementSales) => engagementSales.summaryStats
);

export const getListIsLoading = createSelector(
    [getEngagementSalesListState],
    (listState) => listState.isLoading
);

export const getListIsFirstLoad = createSelector(
    [getEngagementSalesListState],
    (listState) => listState.isFirstLoad
);

export const getListItems = createSelector(
    [getEngagementSalesListState],
    (listState) => listState.listItems
);

export const getListMeta = createSelector(
    [getEngagementSalesListState],
    (listState) => listState.meta
);

export const getListErrorMessage = createSelector(
    [getEngagementSalesListState],
    (listState) => listState.errorMessage
);

export const getSummaryStats = createSelector(
    [getEngagementSalesSummaryStatsState],
    (summaryStatsState) => summaryStatsState.stats
);

export const getSummaryStatsIsLoading = createSelector(
    [getEngagementSalesSummaryStatsState],
    (summaryStatsState) => summaryStatsState.isLoading
);
